<template>
    <div class="input-group mb-3">
      <label :for="item.id" class="col-sm-2 col-form-label">{{ item.name }}</label>
      <div class="col-sm-10">
        <div class="form-check">
          <input class="form-check-input mt-0" type="checkbox" :id="item.id" :name="item.id" value="1" v-model="isChecked" :disabled="!item.isVisible" @change="updateValue">
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    data() {
      console.log("item ", this.item)
      return {
        isChecked: this.item.value === "1",
      };
    },
    methods: {
      updateValue(event) {
        const newValue = event.target.checked;
        this.$emit('updateValue', { id: this.item.id, value: newValue ? "1" : "0" });
      }
    }
  }
  </script>